<template>
  <div>
    <!-- <custom-header title="部门与员工" > -->
      <!-- 使用具名插槽 -->
      <!-- <template slot="right">

      </template> -->
    <!-- </custom-header> -->
    <Breadcrumb></Breadcrumb>
    <ak-model-filter-card model="storeInfoUpdate" @search="search" @reset="reset" :value="where"/>
    <ak-model-card model="storeInfoUpdate" :filters="filters" :page.sync="page" tableSize="small" title="门店修改" />

  </div>
</template>
<script>
import Breadcrumb from '../../components/tools/Breadcrumb.vue'
import { mapState } from 'vuex'
import qs from 'qs'
export default {
  components: {
    Breadcrumb
  },
  data () {
    return {
      filters: {},
      page: Number(this.$route.query.page) || 1
    }
  },
  watch: {
    page (val) {
      this.reRoute()
    }
  },
  computed: {
    ...mapState(['user']),
    where () {
      let where = this.$tkHelper.deepClone(this.filters)
      for (let i in where) {
        if (where[i].$regex) {
          where[i] = where[i].$regex
        }
        if (where[i].$inQuery) {
          delete where[i]
        }
      }
      return where
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {
      this.setFilters()
      this.filters = {
        ...this.filters,
        ...this.$route.query.filters ? qs.parse(this.$route.query.filters) : {}
      }
    },
    search (filters) {
      // filters是组件自动生成的where搜索参数
      this.page = 1
      this.filters = filters
      this.reRoute()
    },
    reset () {
      this.page = 1
      this.filters = {}
      this.setFilters()
      this.reRoute()
    },
    setFilters () {
      this.filters.store = {
        $inQuery: {
          where: {
            isDelete: {
              $ne: true
            }
          },
          className: 'store'
        }
      }
      if (this.$store.state.user.level === '3') {
        // 代理商
        this.filters.type = 'store'
        this.filters.store = {
          $inQuery: {
            where: {
              agent: this.$store.state.user.objectId,
              isDelete: {
                $ne: true
              }
            },
            className: 'store'
          }
        }
      } else if (this.$store.state.user.level === '4') {
        // 业务员
        this.filters.type = 'store'
        this.filters.store = {
          $inQuery: {
            where: {
              agent: this.$store.state.user.agent,
              isDelete: {
                $ne: true
              }
            },
            className: 'store'
          }
        }
      } else if (this.$store.state.user.level === '1') {
        // 战区
        this.filters.store = {
          $inQuery: {
            where: {
              warZone: this.$store.state.user.department,
              isDelete: {
                $ne: true
              }
            },
            className: 'store'
          }
        }
      } else if (this.$store.state.user.level === '2') {
        // 大区
        this.filters.store = {
          $inQuery: {
            where: {
              regional: this.$store.state.user.department,
              isDelete: {
                $ne: true
              }
            },
            className: 'store'
          }
        }
      }
    },
    reRoute () {
      let query = {}
      if (Number(this.page) > 1) query.page = this.page
      if (this.filters && Object.keys(this.filters).length > 0) query.filters = qs.stringify(this.filters)
      console.log(query, 'queryqueryqueryqueryquery')
      this.$router.replace({
        path: this.$route.path,
        query: query
      }).catch(() => {})
    }
  }
}
</script>
<style lang="scss" scoped>
.amdin_role_card{
  height: 152px;
  color: #152137;
}
</style>
